export default __webpack_public_path__ + "assets/models/a1d7533163a71b836d33274a7efebcf4.glb";